import HtmlElement from '../../../../Js/Elements/HtmlElement';
import Countdown from './Countdown';
import Percentage from './Percentage';
import {CountUp} from "countup.js";

const sprintf = (str, ...argv) => !argv.length ? str :
	sprintf(str = str.replace(sprintf.token||"%s", argv.shift()), ...argv);

/**
 * Countdown
 */
const Scarcity = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		SCARCITY: '.scarcity',
		AVAILABILITY: '.scarcity-availability',
		COUNTDOWN: '.scarcity-countdown',
		WRAP: '.scarcity-wrap',
		PERCENTAGE: '.scarcity-percentage',
		AVAILABILITY_TEXT: '.scarcity-availability-text',
		FINISHED: '.scarcity-finished'
	};

	/**
	 * Scarcity
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Scarcity extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this._uid = this.$element.data('uid');
			this._content = this.$element.data('content');
			this._$wrap = this.$element.find(Selector.WRAP);

			this._fetch();

			this.setBodyPadding();

			$(window).on('resize', () => {
				this.setBodyPadding();
			});

			const resizeObserver = new ResizeObserver((entries) => {
				for (const entry of entries) {
					this.setBodyPadding();
				}
			});

			if (this.$element.hasClass('is-sticky')) {
				resizeObserver.observe(this.$element.get(0));
			}
		}

		setBodyPadding() {
			if (this.$element.hasClass('is-sticky')) {
				$('body').css('padding-bottom', `${this.$element.outerHeight(true)}px`);
			}
		}

		_fetch() {
			$.ajax({
				url: window.location.origin,
				type: 'GET',
				data: {
					type: 5250,
					s: this._uid,
					c: this._content
				},
				success: (data) => {
					const $html = $(data);
					const $finished = $html.find(Selector.FINISHED);

					if ($finished.length) {
						this._triggerFinished();
					} else {
						const $availabilityText = $html.find(Selector.AVAILABILITY_TEXT);
						const $percentage = $html.find(Selector.PERCENTAGE);
						const $countdown = $html.find(Selector.COUNTDOWN);

						const text = $availabilityText.data('text');
						const total = $availabilityText.data('total');
						let value = $availabilityText.data('value');

						if ($percentage.length) {
							value = $percentage.data('current');
						}

						if ($availabilityText.length) {
							this._initializeAvailability(sprintf(text, `<span class="scarcity-availability-value">${value}</span>`, total), $percentage, $availabilityText);
						}

						if ($countdown.length) {
							this._initializeCountdown($countdown.data('end'));
						}
					}
				}
			});
		}

		_initializeAvailability(availabilityTextHtml, $percentage, $availabilityText) {
			const $availability = this.$element.find(Selector.AVAILABILITY);
			const $value = this.$element.find(Selector.AVAILABILITY_TEXT);
			$value.html(availabilityTextHtml);
			$availability.addClass('initialized');
			this.setBodyPadding();

			if ($percentage.length) {
				this._initializePercentage($percentage.data('current'), $percentage.data('max'));
			} else if (this.$element.data('type') == 1) {
				const easingFn = (t, b, c, d) => {
					const ts = (t /= d) * t;
					const tc = ts * t;
					return b + c * (tc + -3 * ts + 3 * t);
				};

				const counter = new CountUp(this.$element.find('.scarcity-availability-value').get(0), $availabilityText.data('current'), {
					duration: 6000 / 1000 * 1.1,
					easingFn
				});

				if (!counter.error) {
					setTimeout(() => {
						counter.start();
					}, 500);
				} else {
					console.error(counter.error);
				}
			}
		}

		_initializePercentage(current, max) {
			const $percentage = this.$element.find(Selector.PERCENTAGE);
			$percentage.data('current', current);
			$percentage.data('max', max);
			const percentage = new Percentage($percentage);
			percentage.onReady();
			this.setBodyPadding();
		}

		_initializeCountdown(endTimestamp) {
			const $countdown = this.$element.find(Selector.COUNTDOWN);
			$countdown.data('end', endTimestamp);
			const countdown = new Countdown($countdown);
			countdown.onReady();
			this.setBodyPadding();
		}

		_triggerFinished() {
			const $finished = this.$element.find(Selector.FINISHED);
			this._$wrap.fadeOut(300, () => {
				$finished.fadeIn(300);
			});
		}
	}

	return Scarcity._getElements(Selector.SCARCITY, Scarcity);
})();

export default Scarcity;
